import React, { useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { Button, Input, showToast } from '@attentive-platform/stem-ui';

import TradesPanel from './TradesPanel';
import { GeneratePDFIcon } from '../rosettaSvgs';
import ScopeDetailsPanel from './ScopeDetailsPanel';
import PriceSummaryPanel from './PriceSummaryPanel';
import { GENERATE_ESTIMATE_PDF } from '../../../urls';
import { fetchApiData } from '../../../Utils/ApiCalls';
import { useRosettaStore } from '../../../Stores/useRosettaStore';

const GeneratePDFPanel = () => {
  const { loading, selectedTrades, selectedScopes, customScopes, dispatch } = useRosettaStore(
    useShallow(state => ({
      loading: state.loading,
      selectedTrades: state.selectedTrades,
      selectedScopes: state.selectedScopes,
      customScopes: state.customScopes,
      dispatch: state.dispatch
    }))
  );

  const [companyName, setCompanyName] = useState('');

  const handleCompanyNameChange = e => {
    setCompanyName(e.target.value);
  };

  const handleGeneratePDF = async () => {
    try {
      if (!companyName) {
        showToast('Company name is required', 'error');
        return;
      }

      dispatch({ type: 'SET_LOADING', payload: true });

      const trades = Array.from(selectedTrades).map(tradeId => ({
        id: tradeId,
        notes: customScopes[tradeId] || '',
        scope_ids: Array.from(selectedScopes[tradeId] || [])
      }));

      const payload = {
        company_name: companyName,
        trades,
        scope_mode: true
      };

      const response = await fetchApiData({
        data: payload,
        apiRequest: 'POST',
        endpoint: GENERATE_ESTIMATE_PDF
      });

      if (response.error) {
        showToast(response.error, 'error');
        return;
      }

      showToast('PDF generated successfully!', 'success');

      if (response.data.download_url) {
        window.open(response.data.download_url, '_blank');
      }
    } catch (error) {
      showToast('Error generating PDF. Please try again.', 'error');
    } finally {
      dispatch({ type: 'SET_LOADING', payload: false });
    }
  };

  return (
    <div>
      <div className='mb-4'>
        <p className='block text-sm font-medium text-gray-700 mb-2'>Company Name</p>
        <Input
          type='text'
          size='small'
          className='w-[90%]'
          value={companyName}
          placeholder='Enter company name'
          onChange={handleCompanyNameChange}
        />
      </div>
      <Button
        size='medium'
        loading={loading}
        variant='contained'
        onClick={handleGeneratePDF}
        disabled={loading || selectedTrades.size === 0}>
        <span>
          <GeneratePDFIcon />
          <span className='ml-2'>{loading ? 'Generating PDF...' : 'Generate Estimate PDF'}</span>
        </span>
      </Button>
    </div>
  );
};

const ScopeSelectionTab = () => {
  const { scopeMode } = useRosettaStore(
    useShallow(state => ({
      scopeMode: state.scopeMode
    }))
  );

  return (
    <div className='rosetta-scope-container'>
      {/* Left Panel: Trade Selection */}
      <TradesPanel />

      {/* Center Panel: Scope Details */}
      <ScopeDetailsPanel />

      {/* Right Panel: Quick Summary or Generate PDF Button */}
      {scopeMode ? <GeneratePDFPanel /> : <PriceSummaryPanel />}
    </div>
  );
};

export default ScopeSelectionTab;
